import { ChatLayoutProvider } from "~/shared/context/ChatLayoutContext";
import { ChatShellEmpty } from "~/pages/chat/shell/ChatShellEmpty";

export function ChatEmptyPage() {
    return (
        <ChatLayoutProvider heroMedia mobileQuickActions>
            <ChatShellEmpty />
        </ChatLayoutProvider>
    );
}
